function initSalesInquiryForm(): void {
    const topics = document.querySelectorAll<HTMLInputElement>("input[name='sales_inquiry_form[topic]']");

    // A field that does not apply to the topic is disabled rather than only hidden, so the
    // browser neither submits it nor blocks the submit on its required attribute. Its value
    // stays put, so switching back to the topic brings it back as the visitor left it.
    const fields = [
        { id: "sales_inquiry_form_license", applies: (topic: string) => topic === "pricing" },
        { id: "sales_inquiry_form_group_size", applies: (topic: string) => topic !== "partnership" },
    ];

    const showFieldsFor = (topic: string): void => {
        for (const { id, applies } of fields) {
            const control = document.getElementById(id) as HTMLSelectElement;
            control.disabled = !applies(topic);
            document.getElementById(`${id}_field`).classList.toggle("hidden", control.disabled);
        }
    };

    topics.forEach((topic) => topic.addEventListener("change", () => showFieldsFor(topic.value)));

    // A reload or a back navigation can restore another checked topic than the one the page
    // was rendered for. The browser does that after the load event without firing a change
    // event, so the fields follow the checked topic again once the page is shown.
    window.addEventListener("pageshow", () => {
        const checked = Array.from(topics).find((topic) => topic.checked);
        if (checked) {
            showFieldsFor(checked.value);
        }
    });
}

export { initSalesInquiryForm };
